// extracted by mini-css-extract-plugin
export default {"container":"SectionTitleBlock_container__fp+mv","title":"SectionTitleBlock_title__psGdl"};